module.exports = __webpack_public_path__ + "img/rwfb-icon.26d2e21e.png";